
<template>
  <div class="login">
     <div style="position:relative; width:100%;border-bottom:1px solid #ddd;padding:10px 0"><img src="../../../static/admin-big-logo.png" width="120" class="ml-2"></div>
     
    <div class="container">
    <div class="row">
      <div class="col-12 col-md-6  m-auto">
       
        <div class=""  style="margin-top: 30%;">
            
         
          <h1 class="mb-0 ml-3 text-center">{{logo}}</h1>
          <div class="card-body">
            <el-form ref="form" :model="form" :rules="rules">

               <el-form-item  :label="$t('nav.도메인')" prop="domain" v-if="this.domain_input" >
                    <el-input v-model="form.domain" :placeholder="$t('nav.도메인')" size="medium"></el-input>
                 </el-form-item>

                 <el-form-item :label="$t('nav.아이디')" prop="username">
                    <el-input v-model="form.username" :placeholder="$t('nav.아이디')" size="medium"></el-input>
                 </el-form-item>
                 <el-form-item :label="$t('nav.비밀번호')" prop="password">
                    <el-input v-model="form.password" :placeholder="$t('nav.비밀번호')" type="password"></el-input>
                 </el-form-item>
                  <el-form-item>
                    <el-button type="primary" class="w-100" @click="onSubmit" :loading="loading">{{loading? 'login...' : 'login'}}</el-button>
                 </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  </div>
</template>
<script>

export default {
  data() {
    return {
      
       screenWidth: 0,
      i18n:this.$i18n.t("msg"),
      logo:'',
      domain_input:false,
      loading:false,
      form:{
        username:'',
        password:'',
        domain:''
      },
      rules:{
         username: [
                { required: true, message: this.$i18n.t("msg.아이디를입력하세요"), trigger: 'blur' },
               
          ],
          password: [
                { required: true, message: this.$i18n.t("msg.비밀번호를입력하세요"), trigger: 'blur' },
              
              ],
              domain: [
                { required: true, message: this.$i18n.t("msg.도메인을입력하세요"), trigger: 'blur' },
              
              ],
      },

    };
  },
  created() {

    this.getScreenSize();
    console.log(this.screenWidth)
    
    if(this.screenWidth <= 990){
      
       this.$router.push({ name: 'loginm1'})
    }

    //console.log('t',this.i18n.아이디를입력하세요)

   // this.domain_input=true;

      let hh=document.domain.split('.').slice(-2).join('.');
     console.log('hh',hh)
     let zz=hh.replace('adm','www');
     //zz=hh.replace('pt','www');

     this.form.domain=zz;

    this.$axios({
                method:'post',
                url:'https://flow.bd7080.com/get_domain',
                data:{    //这里是发送给后台的数据
                     domain: window.location.host
                }
            }).then((response) =>{ 
                   if(response.data.code==200)
                   {
                     this.logo=response.data.site;
                      if(response.data.msg!="")
                      {
                        
                         this.form.domain=response.data.msg;
                        
                      }else
                      {
                          this.domain_input=true;
                      }
                   }
                
            }).catch((error) =>{
                 this.domain_input=true;
                console.log(error)       //请求失败返回的数据
            })


    },
  methods: {
     getScreenSize() {
      this.screenWidth = document.documentElement.clientWidth;
      
    },
     
    onSubmit(){
      this.$refs.form.validate((e) =>{
        if(!e) return;
        this.loading =true

        let domain=this.form.domain;
        if(domain.indexOf("http")>-1 )
        { 
            
                    this.$message({
                      type:'error',
                      message:'https:// DELETE'
                    }) 
                    this.loading = false
        }

        this.$axios({
                method:'post',
                url:'https://'+this.form.domain+'/apilogin',
                data:{    //这里是发送给后台的数据
                      username:this.form.username,
                      password:this.form.password,
                      domain:this.form.domain,
                }
            }).then((response) =>{ 
                   
                if(response.data.code!=200)
                {
                    this.$message.error(response.data.msg);
                    this.loading = false
                }else
                {
                    

                    let sitedata= response.data;

                    window.sessionStorage.setItem('user',response.data.data.access_token)
                    window.sessionStorage.setItem('userid',this.form.username)
                    window.sessionStorage.setItem('site',sitedata.site+'')
                    window.sessionStorage.setItem('domain','https://'+this.form.domain)
                    window.sessionStorage.setItem('sitetype',sitedata.sitetype)
                    window.sessionStorage.setItem('outbet',sitedata.outbet)
                    window.sessionStorage.setItem('adminmemo',sitedata.adminmemo)
                    window.sessionStorage.setItem('grobet',sitedata.grobet)
                    window.sessionStorage.setItem('bg',sitedata.bg)
                    window.sessionStorage.setItem('sound',sitedata.sound)
                    window.sessionStorage.setItem('power',sitedata.power)
                    window.sessionStorage.setItem('admin_id',sitedata.admin_id)
                    window.sessionStorage.setItem('rosing',sitedata.rosing)
                    window.sessionStorage.setItem('api_type',sitedata.api_type)
                    window.sessionStorage.setItem('sim',sitedata.sim)
                    window.sessionStorage.setItem('pasing',sitedata.pasing)

                    localStorage.setItem('navActive',JSON.stringify({
                      top:'0',
                      left:'dashboard_index'
                    }))
                   
                    // 成功提示
                    this.$message({
                      type:'success',
                      message:this.$i18n.t("msg.성공적로그인")
                    })
                    this.loading = false
                    // 跳转后台首页
                   
                     this.$router.push({ name: 'memlist_list', params: { rand: Math.random() }})
                   //  this.$router.push({name:'dashboard_index'})


                }
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
                this.$message.error(error);
                this.loading = false
            })
        
      })

    },


  },
}

</script>
<style scoped>
 body{background:#fff}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue